import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const FRAMES = [
  "/assets/sweep-f1.png",
  "/assets/sweep-f2.png",
  "/assets/sweep-f3.png",
  "/assets/sweep-f4.png",
  "/assets/sweep-f5.png",
];

// frame 1 plays once (the big 45°→225° swing), then 2–5 loop (30°→225°)
const SEQUENCE = [0, 1, 2, 3, 4, 1, 2, 3, 4, 1, 2, 3, 4, 1, 2, 3, 4];
const STEP_MS = 420;

export default function ErasedHoof() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false, margin: "-20% 0px" });
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (!inView) {
      setStep(0);
      return undefined;
    }
    const id = setInterval(
      () => setStep((s) => (s + 1) % SEQUENCE.length),
      STEP_MS,
    );
    return () => clearInterval(id);
  }, [inView]);

  return (
    <div
      ref={ref}
      data-testid="erased-hoof"
      className="relative mx-auto h-24 w-full max-w-lg sm:h-28"
      aria-hidden="true"
    >
      <img
        src={FRAMES[SEQUENCE[step]]}
        alt=""
        data-testid="sweep-woman"
        className="absolute bottom-0 left-0 w-[76%]"
      />
      <img
        src="/assets/sweep-cows.png"
        alt=""
        className="absolute bottom-1 right-0 h-12 w-auto sm:h-14"
      />
    </div>
  );
}
